import { EventsOfTask } from 'pages/Tasks/types'
import type { Action } from 'redesign/components/organisms/action-wrapper/types'
import { TASK_STATES } from '../../ContentLists/TaskList/constants'
import type { GetReminderButtonProps } from './types'

export const getReminderButton = ({ t, sendEvent, isOffice, task, refetch }: GetReminderButtonProps): Action => {
  const reminderEvent = isOffice ? EventsOfTask.sendReminderToFrontline : EventsOfTask.sendReminderToManager

  const submit = () => {
    if (!isOffice && task.statusFe === TASK_STATES.todo) return

    sendEvent(reminderEvent, undefined, refetch)
  }

  return {
    label: t('button.sendReminder'),
    onClick: submit,
    testId: 'task_detail_send_reminder',
  } as Action
}
